function HasClass( el, cls )
{
    var current = el.getAttribute( "class" );
    return ( ( current != undefined ) && ( current.indexOf( cls ) != -1 ) );
}

function AddClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( ( current == undefined ) || ( current.indexOf( cls ) == -1 ) )
        {
            current += " " + cls;
            el.setAttribute( "class", current );
        }
    }
}
function RemoveClass( el, cls )
{
    if ( el )
    {
        var current = el.getAttribute( "class" );
        if ( current )
        {
            current = current.replace( cls, ' ' );
            el.setAttribute( "class", current );
        }
    }
}
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

function getChosenVariant( element )
{
    var options     = element.querySelectorAll( "option" );
    var container   = SearchParentsFor( element, "collection_product_container" );
    var priceContainer = container.querySelector( ".collection_product_price" );

    for( var i = 0; i < options.length; i++ )
    {
        var option      = options[ i ];
        var selected    = element.selectedIndex;

        if( i == selected )
        {
            element.dataset.option  = option.value;
            element.dataset.variant = option.dataset.variant;
            if( option.dataset.price )
            {
                priceContainer.innerHTML = option.dataset.price;
            }
            // setupEdgeTPReviews( option );
        }
    }
}

function setupEdgeTPReviews( selectedOption )
{
    var parent      = SearchParentsFor( selectedOption, "collection_product_container" );
    var tpReviews   = parent.querySelectorAll( ".edge-tp" );
    var select      = parent.querySelector( "select[ name='id' ]" );
    var options     = select.querySelectorAll( "option" );
    var variantId;

    for( var i = 0; i < options.length; i++ )
    {
        var option = options[ i ];
        if( option.dataset.option == selectedOption.value  )
        {
            variantId = option.value;
        }
    }

    for( var i = 0; i < tpReviews.length; i++ )
    {
        var review  = tpReviews[ i ];
        review.classList.add( "hidden" );
        // console.log( review.dataset.variantID );
        if( variantId == review.dataset.variantId )
        {
            review.classList.remove( "hidden" );
        }
    }

}

function toggleActiveClass( element )
{
    var parent = SearchParentsFor( element, "collection_select_container" );
    var error  = parent.querySelector( ".option-err-msg" );
    var variant_available = element.dataset.available;
    var oos_parent   = SearchParentsFor( element,"strength-and-cta" );
    var add_to_cart_button = oos_parent.querySelector( ".cart-cta-container" );
    if (variant_available == "false") 
    {
        add_to_cart_button.innerHTML = "OUT OF STOCK";
        add_to_cart_button.setAttribute( "style", "cursor: default;opacity: 0.5;pointer-events: none;" );
    }
    else
    {
        add_to_cart_button.innerHTML = "ADD TO BASKET";
        add_to_cart_button.removeAttribute('style');
    }
    if( error )
    {
        error.remove();
    }
    var variants = parent.querySelectorAll( ".variant-type" );

    for( var i = 0; i < variants.length; i++ )
    {
        var variant = variants[ i ];
        variant.classList.remove( "active" );
    }

    if( !element.classList.contains( "active" ) )
    {
        element.classList.add( "active" );
    }
    else
    {
        element.classList.remove( "active" );
    }

    var productId       = parent.getAttribute( "data-product-id" );
    var productData     = document.getElementById( "product-data-" + productId );
    productData         = JSON.parse( productData.innerHTML );
    console.log(productData);
    var selectedVariant = parent.querySelector( ".variant-type.active" );
    productData.variants.forEach( function( variant )
    {
        if( selectedVariant && variant.id == selectedVariant.dataset.variant )
        {
            parent.closest(".prod-info-container" ).querySelector( "#ProductPrice" ).innerHTML = FormatMoney( 'en-gb', "GBP", ( variant.price / 100 ) );
            if( variant.compare_at_price > variant.price )
            {
                parent.closest(".prod-info-container" ).querySelector( "#ComparePrice").innerHTML = FormatMoney( 'en-gb', "GBP", ( variant.compare_at_price / 100 ) );
                parent.closest(".prod-info-container" ).querySelector( "#ComparePrice").classList.remove( "visually-hidden" );
            }
            else
            {
                parent.closest(".prod-info-container" ).querySelector( "#ComparePrice").classList.add( "visually-hidden" );
            }
        }
    });
}

function handleOptionErrMessage( element )
{
    var parent      = SearchParentsFor( element, "strength-and-cta" ); 
    var container   = parent.querySelector( ".strength-container" );
    var p           = document.createElement( "p" );
    p.innerHTML     = "Please select an option";
    p.setAttribute( "style", "color: #b9a163; font-size: 17px" );
    p.setAttribute( "class", "option-err-msg" );
    p.classList.add( "collection-error" );
    container.appendChild( p );
}

function updateChosenVariant( element )
{
    stopPropagation( );
    // var selectContainers        = document.querySelectorAll( ".cart--item" );
    // var parent                  = SearchParentsFor( element, "collection_product_container" );
    var productInfoContainer    = SearchParentsFor( element, "collection-product-info-container" );
    var select                 = productInfoContainer.querySelector( "select" );

    if( select )
    {
        var product = select.dataset.variant;
        if( product )
        {
            UpdateProduct( product, element );
        }
    }
    else
    {
        var variant = productInfoContainer.querySelector( ".collection_select_container .active" );
        if( !variant )
        {           
            handleOptionErrMessage( element )
        }
        else 
        {
            var product = variant.dataset.variant;
            if( product )
            {
                UpdateProduct( product, element );
            }
        }
    }
}

function UpdateProduct( value, element )
{

    var newVariant      = value;
    var qty             = 1;

    var xhr     = new XMLHttpRequest( );
    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            if ( xhr.status == 200 )
            {
                // AddNewVariant( qty, newVariant );
                // console.log( "added" );
                handleProductAdded( element );
            }
            else
            {
                console.log( "adding variant failed" + xhr.responseText );
                handleBadRequest( JSON.parse( xhr.response ), element );
            }
        }
    };

    xhr.open( "POST", "/cart/add.js", true );
    xhr.setRequestHeader( "Content-Type", "application/json" );
    xhr.send( JSON.stringify( { "quantity" : qty, "id" : newVariant } ) );

}

function handleBadRequest( response, element )
{
    // var parent      = SearchParentsFor( element, "collection_product_container" ); 
    // var container   = parent.querySelector( ".collection_select_container" );
    var parent      = SearchParentsFor( element, "strength-and-cta" ); 
    var container   = parent.querySelector( ".strength-container" );
    if( !container.querySelector( ".collection-error" ) )
    {
        var p           = document.createElement( "p" );
        var option      = parent.querySelector( ".visible-option" ).dataset.option;
        p.innerHTML     = "Please select a " + option;
        p.setAttribute( "style", "color: #b9a163; font-size: 17px" );
        p.classList.add( "collection-error" );
        container.appendChild( p );
    }
}

function handleProductAdded( element )
{
    // var parent      = SearchParentsFor( element, "collection_product_container" ); 
    // var container   = parent.querySelector( ".collection_select_container" );
    // var error       = container.querySelector( ".collection-error" );
    var parent      = SearchParentsFor( element, "strength-and-cta" ); 
    var container   = parent.querySelector( ".collection_select_container" );
    var error       = parent.querySelector( ".collection-error" );
    var cartCount   = document.querySelector( "#CartCount" );
    var span        = cartCount.querySelector( "span" );
    if( error )
    {
        error.parentNode.removeChild( error );
    }

    if( !parent.querySelector( ".collection-added" ) )
    {
        var p           = document.createElement( "p" );
        p.innerHTML     = "Added";
        p.setAttribute( "style", "color: #b9a163; font-size: 17px; padding-top: 10px;" );
        p.classList.add( "collection-added" );
        container.appendChild( p );
    }    

    if( span.innerHTML == 0 )
    {
        span.innerHTML = Number( span.innerHTML ) + 1;
        cartCount.classList.remove( "hide" );
    }
    else
    {
        span.innerHTML = Number( span.innerHTML ) + 1;
    }
}

function getProductData( parent, selects )
{
    var option1;
    var option2;
    var option3; 
    var product = {};

    if( selects && selects.length )
    {
        for( var i = 0; i < selects.length; i++ )
        {
            var select = selects[ i ];
            var option = select.dataset.option;
            if( option )
            {
                // console.log( option );
                if( i == 0 )
                {
                    option1 = option;
                }
                if( i == 1 )
                {
                    option2 = option;
                }
                if( i == 2 )
                {
                    option3 = option;
                }
    
                var selectedVariant;
                if( option1 && option2 && option3 )
                {
                    var selectedVariant         = option1 + " / " + option2 + " / " + option3;
                }
                else if( (option1 && option2) && (option3 == undefined) )
                {
                    var selectedVariant         = option1 + " / " + option2;
                }
                else if( (option1) && ( option2 == undefined && option3 == undefined ) )
                {
                    var selectedVariant         = option1;
                }
                // console.log( selectedVariant );
                var productVariant          = parent.querySelector( ".collection-product-select-hidden" );
                var productVariantOptions   = productVariant.querySelectorAll( "option" );
                for( var k = 0; k < productVariantOptions.length; k++ )
                {
                    var productVariantOption = productVariantOptions[ k ];
                    if( selectedVariant == productVariantOption.innerHTML )
                    {
                        product.value   = productVariantOption.value
                        product.url     = productVariantOption.dataset.url;
                    }
                }
            }
            else
            {
                product.url     = parent.querySelector( ".variant-selects-and-ids" ).dataset.producturl;
            }
        }
    }
    else
    {
        //default variant
        product.value = parent.querySelector( ".variant-selects-and-ids option" ).value;
        product.url = parent.querySelector( ".variant-selects-and-ids option" ).dataset.url;
    }
    return product;
}

function ShowProduct( element )
{
    var productInfoContainer;
    var parent;

    if( element.classList.contains( "collection_product_container" ) )
    {
        productInfoContainer    = element.querySelector( ".collection-product-info-container" );
        parent                  = element;
    }
    else
    {
        productInfoContainer    = SearchParentsFor( element, "collection-product-info-container" );
        var parent                  = SearchParentsFor( element, "collection_product_container" );
    }
    var selects                 = productInfoContainer.querySelectorAll( "select" );

    var product = getProductData( parent, selects );
    // console.log( product );
    if( product )
    {
        GoToProduct( product.url );
    }
}

function GoToProduct( url )
{
    window.location.href = url;
}

function stopPropagation( )
{
    window.event.preventDefault();
    window.event.stopPropagation();
}

function InitialiseCollectionPage()
{
    showFilter();
    ShowCollectionDescription();
}

function ShowCollectionDescription()
{
    var containers = document.querySelectorAll( ".collection_description_target" );
    for( var i = 0; i < containers.length; i++ )
    {
        var container = containers[ i ];
        if( window.innerWidth > 768 )
        {
            container.querySelector( ".collection_metafield_title_container" ).click();
        }
    }
}

function showFilter()
{
    var collectionHandle    = document.querySelector( ".collection_metafield_title_container" ).dataset.handle;
    var pathname            = window.location.pathname;
    var urlFilter           = pathname.replace( "/collections/" + collectionHandle + "/", '' );
    var filter              = urlFilter.split( '-' )[ 0 ];

    // var filterContainer     = document.querySelector( ".collection_left_filter_container" );
    var filterContainer     = document.querySelector( ".edge-collection_left_filter_container" );
    var filterTitles        = filterContainer.querySelectorAll( ".collection_metafield_title_container p" );
    var selectedFilter;
    var filteredCollection  = false;

    for( var i = 0; i < filterTitles.length; i++ )
    {
        var title = filterTitles[ i ];
        // console.log( 'here' );
        if( title.innerHTML == ( filter.charAt( 0 ).toUpperCase() + filter.slice( 1 ) ) )
        {
            selectedFilter = title.parentNode;
            filteredCollection = true;
            break;
        }
    }

    if( filteredCollection )
    {
        var parent      = SearchParentsFor( selectedFilter, "filter-container" );
        var filters     = parent.querySelectorAll( ".collection_child_link-text-container" );
        for( var i = 0; i < filters.length; i++ )
        {
            var filter      = filters[ i ];
            var container   = SearchParentsFor( filter, "collection_child_link-container" );
            if( filter.dataset.filter == urlFilter.split( '-' )[ 1 ] )
            {
                var imageContainer = container.querySelector(".collection_child_link-image-container" );
                imageContainer.querySelector( "img" ).src = imageContainer.dataset.activeimage;
            }
            else if( filter.dataset.filter == urlFilter.split( '-' )[ 1 ] + "-" + urlFilter.split( '-' )[ 2 ] )
            {
                var imageContainer = container.querySelector(".collection_child_link-image-container" );
                imageContainer.querySelector( "img" ).src = imageContainer.dataset.activeimage;                
            }
        }
    }

    if( selectedFilter == undefined )
    {
        if( pathname.includes( collectionHandle ) )
        {
            selectedFilter = document.querySelector( ".range-filter" );
        }
    }

    if( selectedFilter )
    {
        RevealMetadataCollection( selectedFilter );
    }

}

function filterGoToCollection( element )
{
    var parent  = SearchParentsFor( element, "collection_metafield_content_inner" );
    var images  = parent.querySelectorAll( ".filter-image" );

    for( var i = 0; i < images.length; i++ )
    {
        var image = images[ i ];

        if( image.src.includes( element.dataset.activeimage ) )
        {
            image.src = element.dataset.inactiveimage;
        }
    }

    element.querySelector( "img" ).src = element.dataset.activeimage;

    window.location.href = element.dataset.url;
}

function revealFilterDropdown( element )
{
    var parent = element.parentNode;
    var dropdown = parent.querySelector( ".edge-filter-dropdown-mob" );
    dropdown.classList.toggle( "hidden" );
}
  
var mediaQuery = window.matchMedia("(max-width: 750px)")

window.addEventListener( "DOMContentLoaded", function()
{
    InitialiseCollectionPage();
} );